import React from "react";
import styles from "./description.module.css";

class StructureTab extends React.Component {
  render() {
    return (
      <div className={styles.structureTabContainer}>
        <div>
          Для сбора данных у абонента устанавливается оборудование удаленного
          доступа к теплосчётчику, которое включает в себя модем или GSM-модем.
          Сбор данных происходит в ночное время. Данные хранятся на сервере ИС
          «Теплоинформ»
        </div>
        <div style={{ fontWeight: "600", paddingTop: "1.7vh" }}>
          Описание работы с интернет-службой "Теплоинформ"
        </div>
        <div>
          Доступ к ИС <span style={{ fontWeight: "600" }}>«Теплоинформ»</span>{" "}
          осуществляется через интернет. Для получения доступа к личному
          кабинету необходимо обратиться в службу технической поддержки, затем
          зайти на сайт{" "}
          <a
            href="http://teplo-inform.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.teplo-inform.ru
          </a>{" "}
          в личный кабинет и ввести имя и пароль.
        </div>
        <div style={{ paddingTop: "1.7vh" }}>
          После этого пользователь попадает в личный кабинет, в котором может
          заказать посуточную или почасовую ведомость теплопотребления.
        </div>
      </div>
    );
  }
}

export default StructureTab;
